export default {
  "Enter your email and password to sign in": "输入电邮及密码登入",
  "Sign In": "登入",
  "Login email": "登入电邮",
  English: "英文",
  "Traditional Chinese": "繁体中文",
  "Simplified Chinese": "简体中文",
  "Search...": "搜索...",
  new: "新增",
  Edit: "编辑",
  edit: "编辑",
  save: "储存",
  Page: "网页",
  Pages: "网页",
  pages: "网页",
  "New Page": "新增网页",
  "Edit Page": "编辑网页",
  All: "全部",
  Draft: "草稿",
  draft: "草稿",
  Scheduled: "已排期",
  Published: "已放布",
  Suspended: "停止放布",
  "Enter Content": "输入内容",
  "Enter CSS": "输入CSS",
  "Search Engine Optimization": "搜寻引擎优化 SEO",
  "Meta Title": "Meta 标题",
  "Enter Meta Title": "输入 Meta 标题",
  "Meta Keywords": "Meta 关键字",
  "Enter Meta Keywords": "输入 Meta 关键字",
  "Description": "描述",
  "Enter Description": "输入描述",
  "Meta Description": "Meta 描述",
  "Enter Meta Description": "输入 Meta 描述",
  "Page Settings": "网页设置",
  "Last edit": "最后修改",
  "Push Notification": "推送",
  "Push Notification Setting": "推送设定",
  "Enable": "开启",
  "Disable": "关闭",
  "Optional": "可选",
  Content: "内容",
  status: "状态",
  STATUS: "状态",
  Slug: "链结名称",
  slug: "链结名称",
  Title: "网页名称",
  title: "网页名称",
  "Published on": "发布于",
  "Editted on": "编辑于",
  "Missing title": "必须输入网页名称",
  "Missing slug": "必须输入链结名称",
  "posts": "贴文",
  "Posts": "贴文",
  "post types": "贴文类型",
  "Post Type": "贴文类型",
  "Post Types": "贴文类型",
  "Post Settings": "贴文设置",
  "New Post Type": "新增贴文类型",
  "Edit Post Type": "新增贴文类型",
  "Post Type Name": "贴文类型名称",
  "No. of Posts": "贴文数量",
  "Created On": "建立于",
  "Editted On": "编辑于",
  "Categories": "种类",
  "Sub-categories": "新手入门主题分类",
  "Beginner Guide": "新手入门",
  "Intermediate": "中级",
  "Advanced": "高级",
  "Gold Agent": "黄金代理",
  "Spot Trading of Gold": "现货黄金",
  "Spot Trading of Silver": "现货白银",
  "London Gold": "伦敦金",
  "London Silver": "伦敦银",
  "New Post": "新增贴文",
  "Edit Post": "编辑贴文",
  "Select a Thumbnail": "选择缩图",
  "Select": "选择",
  "Thumbnail": "缩图",
  "Upload": "上载",
  "Uploaded": "上载完成",
  "Failed": "失败",
  "Library": "媒体库",
  "IMAGE": "图片",
  "FILE NAME": "档案名称",
  "黃金代理": "黄金代理",
  "現貨黃金": "现货黄金",
  "現貨白銀": "现货白银",
  "倫敦銀": "伦敦银",
  "倫敦金": "伦敦金",
  "新手入門": "新手入门",
  "中級": "中级",
  "高級": "高级",
  "News Notice": "消息公告",
  "System Notice": "系统公告",
  "Others Notice": "其他公告",
  "Sub-title": "副标题",
  "Marquee": "走马灯文字",
  "Publish Settings": "发布设置",
  "Schedule to Publish": "排期发布",
  "Publish Now": "立即发布",
  "Publish Date": "发布日期",
  "Publish Time": "发布時間",
  "Content Types": "内容类型",
  "Video Link": "影片连结",
  "External Link": "外部连结",
  "HTML Content": "HTML 内容",
  "Invalid date entered": "输入的日期无效",
  "delete": "刪除",
  "Confirm to delete?": "确定删除?",
  "Yes": "是",
  "No": "否",

  "Name": "姓名",
  "Area Code": "区码",
  "Mobile Number": "电话",
  "User Type": "用户类别",
  "Status": "状态",
  "All":"所有",
  "Active": "启用",
  "Inactive":"停用",
  "active": "启用",
  "inactive":"停用",
  "Users":"用户",
  "ADD USER" : "新增用户",
  "Live" : "真实帐户",
  "Demo" : "模拟帐户",
  "Portal User" : "普通帐户",

  "Edit User": "编辑用户",
  "New User": "新增用户",
  "+86 China": "+86 中国",
  "+852 Hong Kong China": "+852 中国香港",
  "+853 Macau China": "+853 中国澳门",
  "+886 Taiwan China": "+886 中国台湾",
  "+60 Malaysia": "+60 马来西亚",
  "+84 Vietnam": "+84 越南",
  "Name is required": "请输入名称",
  "Area Code is required": "请输入区码",
  "Mobile number is required": "请输入电话号码",
  "Mobile number is invalid": "请输入正确电话号码",
  "OA Client ID": "OA Client ID",
  "Price Reminder Expiry Date": "价格提示到期日",
  "Choose a status": "选择状态",
  "Status is required": "请选择状态",
  
  "Real Name": "真实姓名",
  "Gender": "性别",
  "Mobile": "手机号码",
  "Email": "电子邮件",
  "Grade": "客户身份",
  "ID Number": "证件号码",
  "ID Type": "证件类型",
  "Address": "户籍地址",
  "Agent number": "代理号码",
  "Referral Code": "推荐码",
  "Subscribe State": "短讯订阅状态",
  "Club State": "汉声薈注册状态",
  "Club Score": "汉声薈会员积分",
  "Club Level": "汉声薈会员等级",
  "Balance": "余额",
  "Equity": "净值",
  "Margin": "保证金",
  "Male" : "男",
  "Female" : "女",
  "Normal Account" : "普通客户",
  "Professional Account" : "专业投资者",
  "Registered" : "已注册",
  "Not yet register" : "未注册",
  "Subscribed": "已申請",
  "Not yet subscribe": "未申請",
  "China ID" : "中国",
  "Others" : "其他",
  "ID Front Image": "证件正面照",
  "ID Back Image": "证件背面照",
  "ID Hand Held Image": "手持证件照",
  "Bank Card Image": "银行卡照片",
  "View Image": "显示图片",
  "Demo Account Information (Read Only)": "模拟帐户资料 (唯读)",
  "OA Information (Read Only)": "OA 帐户资料 (唯读)",
  "Bank Information (Read Only)": "银行资料 (唯读)",
  "Bank Name": "银行名称",
  "Bank User Name":"银行账户姓名",
  "Bank Account": "银行卡账号",
  "Bank Branch": "支行地址",
  
  "Update": "更新",
  "Create": "新增",
  "Cancel":"取消",
  "History":"纪录",
  "settings":"设置",
  "Settings":"设置",
  "Settings Updated":"设置更新成功",
  "Language":"语言",
  "Admin Users":"内部用户",
  "Last Name": "姓氏",
  "First Name": "名称",
  "Mobile Number": "手机号码",
  "Login Email": "登入电邮",
  "Department": "部门",
  "Position": "职位", 
  "Home Page": "首页",
  "LOGOUT": "登出",
  "Logout": "登出",
  "Incorrect password entered": "输入密码不正确",

  "Edit Admin User": "更新内部用户",
  "New Admin User": "新增内部用户",
  "IT": "电脑部",
  "Marketing": "市场部",
  "CS": "客户服务部",
  "Admin": "管理员",
  "Manager": "经理",
  "Staff": "员工",
  "Your email address is invalid": "您的电邮输入不正确",
  "Login email is required": "请输入电邮",
  "Last name is required": "请输入姓氏",
  "First name is required": "请输入名称",
  "Password": "密码",
  "Confirm Password": "确认密码",
  "Password is required": "请输入密码",
  "Password not match with confirm password": "密码和确认密码不相同",
  "Choose a Department": "选择部门",
  "Choose a Position": "选择职位",
  adminUsers: "内部用户",
  users: "用户",
  "Media Library": "媒体库",
  "media library": "媒体库",
  "COPY LINK": "复制连结",
  "ADD IMAGE": "新增图片",
  "Upload": "上载",
  "upload": "上载",
  "Drop files here to upload": "将档案拖曳到此处进行上传",
  "IMAGE": "图片",
  "FILE NAME": "档案名称",
  "REMARK": "备注",
  "COPY LINK": "复制连结",
  "BACK": "返回",
  "Image": "图片",
  "Widget": "工具",
  "Edit Widget": "编辑工具",
  "widgets": "工具",
  "Widget Name": "工具名称",
  "Banners": "横幅",
  "banners": "横幅",
  "Banner": "横幅",
  "Homepage Banner": "首页横额",
  "New Banner": "新增横幅",
  "Add Banner": "新增横幅",
  "URL": "网址",
  "External Link?": "外部连结?",
  "External Link": "外部连结",
  "Internal Link": "内部连结",
  "Confirm": "确定",
  "Missing banner": "必须选择横幅",
  "Missing image": "必须选择图片",
  "Missing text": "必须输入文字",
  "Missing URL": "必须输入网址",
  "Popup": "弹出视窗",
  "Popups": "弹出视窗",
  "popups": "弹出视窗",
  "Homepage Popup": "首页弹出视窗",
  "Add Popup": "新增弹出视窗",
  "New Popup": "新增弹出视窗",
  Text: "文字",
  "Display Date (yyyy-MM-dd)": "显示日期 (yyyy-MM-dd)",
  "Image URL": "图片连结",
};
